import Vue from "vue";

export class Vlan {
    static create() {
        return {
            nome: null,
            numero: null,
            tipo: "CONDOMINIO",
            street: {
                cidade: null,
                bairro: null
            },
            condominio: {
                _id: null
            }
        };
    }

    /**
     *
     * @return {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("vlan/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("vlans")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("vlan", data);
            } else {
                promisse = Vue.http.post("vlan", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
